import { render, staticRenderFns } from "./AnamnesisForm.vue?vue&type=template&id=7ba2d1bc&scoped=true"
import script from "./AnamnesisForm.vue?vue&type=script&lang=js"
export * from "./AnamnesisForm.vue?vue&type=script&lang=js"
import style0 from "./AnamnesisForm.vue?vue&type=style&index=0&id=7ba2d1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba2d1bc",
  null
  
)

export default component.exports